import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsConstructorModule } from 'src/app/forms/forms-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { TableUsersListModule } from 'src/app/views/table-users-list/table-users-list.module';
import { ViewsModule } from 'src/app/views/views.module';
import { BlockedUsersComponent } from './blocked-users/blocked-users.component';
import { ChatContentComponent } from './chat-content/chat-content.component';
import { ChatTabsComponent } from './chat-tabs/chat-tabs.component';
import { ConversationsChatComponent } from './conversations-chat.component';
import { MessageBlockComponent } from './message-block/message-block.component';

@NgModule({
  declarations: [
    ConversationsChatComponent,
    ChatTabsComponent,
    ChatContentComponent,
    MessageBlockComponent,
    BlockedUsersComponent,
  ],
  imports: [
    NgbDropdownModule,
    NgbPaginationModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    SharedModule,
    ViewsModule,
    TableUsersListModule,
    FormsConstructorModule,
  ],
})
export class ChatModule {}
